import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const PlantillaPage: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Catálogos',
            path: `/catalogos/`,
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        Plantillas
      </PageTitle>
      <View />
    </>
  );
};

export { PlantillaPage };
